// Shared helpers so admin preview, public portal and user dashboard render
// the social-links strip identically. Keep this file small — it's just size
// math + counting enabled links.

// Fields on the SocialLinks object that hold a URL (not a toggle or label).
export const SOCIAL_URL_KEYS = [
  'facebook',
  'twitter',
  'linkedin',
  'instagram',
  'youtube',
  'tiktok',
  'bluesky',
  'custom',
];

/**
 * Count how many social platforms are actively displayed for a customer:
 * both the URL is truthy AND the `<platform>_enabled` toggle is on.
 */
export function countEnabledSocialLinks(socialLinks) {
  if (!socialLinks) return 0;
  return SOCIAL_URL_KEYS.reduce((n, key) => {
    return socialLinks[key] && socialLinks[`${key}_enabled`] ? n + 1 : n;
  }, 0);
}

/**
 * Above 5 enabled links the row overflows on typical phone widths, so we
 * shrink everything ~75%. This is picked up by all three render surfaces.
 */
export function socialLinkSizeClasses(enabledCount) {
  const shrink = enabledCount > 5;
  return {
    // container (the round white anchor)
    button: shrink
      ? 'w-9 h-9 sm:w-10 sm:h-10'
      : 'w-12 h-12 sm:w-14 sm:h-14',
    // lucide icon inside
    icon: shrink
      ? 'w-4 h-4 sm:w-5 sm:h-5'
      : 'w-5 h-5 sm:w-6 sm:h-6',
    // gap between buttons
    gap: shrink ? 'gap-1.5 sm:gap-2' : 'gap-2 sm:gap-3',
    shrink,
  };
}
